import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// Firebase custom-token login removed.
// Admin panel is accessed at admin.ccroindia.in / admin.ccroindia.com (device allowlist).
const AdminLogin: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast('Use admin.ccroindia.in or admin.ccroindia.com for the admin panel', { icon: 'ℹ️' });
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-slate-200">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold">Admin Login Removed</h1>
        <p className="text-slate-400">Open the admin panel at admin.ccroindia.in</p>
        <button
          onClick={() => navigate('/')}
          className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-500"
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
